import React from 'react';
import PropTypes from 'prop-types';

/**
 * PrimaryButton Component
 *
 * Large primary action button
 */
export function PrimaryButton({ children, icon, onClick, variant = 'default', className = '' }) {
  const variantStyles = {
    default: 'bg-[#E65100] hover:bg-[#D84315] text-white',
    danger: 'bg-red-600 hover:bg-red-700 text-white',
    success: 'bg-green-600 hover:bg-green-700 text-white',
  };

  return (
    <button
      onClick={onClick}
      className={`
        ${variantStyles[variant]}
        w-full py-5 px-6 rounded-2xl
        text-xl font-bold
        flex items-center justify-center gap-3
        transition-all duration-200
        hover:transform hover:-translate-y-1
        hover:shadow-lg
        ${className}
      `}
    >
      {icon && <span className="text-2xl">{icon}</span>}
      <span>{children}</span>
    </button>
  );
}

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'danger', 'success']),
  className: PropTypes.string
};

/**
 * SecondaryButton Component
 *
 * Secondary action button (lighter style)
 */
export function SecondaryButton({ children, icon, onClick, variant = 'default', centered = false, className = '' }) {
  const variantStyles = {
    default: 'bg-gray-100 hover:bg-gray-200 border-2 border-gray-300 text-gray-800',
    green: 'bg-green-50 hover:bg-green-100 border-2 border-green-300 text-green-800',
  };

  return (
    <button
      onClick={onClick}
      className={`
        ${variantStyles[variant]}
        ${centered ? 'w-full' : ''}
        py-4 px-5 rounded-xl
        text-lg font-semibold
        flex items-center ${centered ? 'justify-center' : 'justify-start'} gap-2
        transition-all duration-200
        hover:transform hover:-translate-y-0.5
        ${className}
      `}
    >
      {icon && <span className="text-xl">{icon}</span>}
      <span>{children}</span>
    </button>
  );
}

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'green']),
  centered: PropTypes.bool,
  className: PropTypes.string
};
